var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.isCarregado
    ? _c(
        "div",
        [
          _c(
            "div",
            {
              staticClass: "row",
              staticStyle: { padding: "5px", "font-size": "16px" },
            },
            [
              _c("div", { staticClass: "col-sm-2" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "__.Crud.devolucaoCompra.edit_vue_html.cabecalhoProduto"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "__.Crud.devolucaoCompra.edit_vue_html.cabecalhoLote"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "__.Components.parent.manipulacao.loteEstoque_vue_html.qtdeEstoque"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "__.Components.parent.manipulacao.loteEstoque_vue_html.qtdePesagem"
                      )
                    )
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("div", { staticClass: "col-sm-2" }, [
                _c("span", [
                  _vm._v(
                    _vm._s(
                      _vm.$t(
                        "__.Components.parent.manipulacao.loteEstoque_vue_html.dataValidadeLote"
                      )
                    )
                  ),
                ]),
              ]),
            ]
          ),
          _vm._v(" "),
          _vm._l(_vm.produtosParaVerificacao, function (item, index) {
            return _c(
              "div",
              { key: item.id || index, staticClass: "row" },
              [
                _c("item-component", {
                  key: index,
                  attrs: {
                    item: item,
                    produtoLoteOptions: _vm.produtoLoteOptions,
                    manipulacaoOrdemId: _vm.manipulacaoOrdemId,
                    movimentacaoEstoqueId: _vm.movimentacaoEstoqueId,
                  },
                  on: {
                    onChangeItem: function (p) {
                      return _vm.onChangeItem(p, index)
                    },
                  },
                }),
              ],
              1
            )
          }),
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }